import { Props as SplitPaneProps } from 'react-split-pane'

export enum WidgetType {
  DIAGRAM = 'diagram',
  CODE = 'code',
  RESULT = 'result',
  CONSOLE = 'console',
  DOCS = 'docs',
  CODE_AI_HELPER = 'codeAIHelper',
  PREVIEW = 'preview'
}

interface IPane {
  key: string
}
export interface ISplitPane extends IPane {
  type: 'pane'
  splitPane: SplitPaneProps
  children: WidgetProps[]
  defaultDividerSize?: number
  dividerKey?: CodeDividers
}
export interface IWidget extends IPane {
  type: 'widget'
  contentType: WidgetType
  dividerKey?: CodeDividers
  defaultDividerSize?: number
}
export type WidgetProps = ISplitPane | IWidget

export type CodeLayout = {
  id: number
  name: string
  defaultName: string
  icon: string
  widgets: WidgetProps
}

export enum CodeDividers {
  DIAGRAM_DIVIDER = 'diagramDivider',
  CODE_DIVIDER = 'codeDivider',
  RESULT_DIVIDER = 'resultDivider',
  CODE_FEEDBACK_DIVIDER = 'codeFeedbackDivider',
  CONSOLE_DIVIDER = 'consoleDivider',
  DOCS_DIVIDER = 'docsDivider',
  CODE_AI_HELPER_DIVIDER = 'codeAIHelperDivider',
  PREVIEW_DIVIDER = 'previewDivider',
  LEFT_PANE_DIVIDER = 'leftPaneDivider',
  RIGHT_PANE_DIVIDER = 'rightPaneDivider',
  CUSTOM_COMPONENT_RESULT_DIVIDER = 'customComponentResultDivider',
  CUSTOM_COMPONENT_CODE_DIVIDER = 'customComponentCodeDivider'
}

export enum Layout {
  DiagramAndResult = 1,
  DiagramCodeAndResult
}
interface Dimension {
  codeDivider?: number
  resultDivider?: number
  previewDivider?: number
  docsDivider?: number
  codeAIHelperDivider?: number
}
export interface CustomDimension {
  result: Dimension
  codeAndResult: Dimension
}
export interface Code {
  layouts?: CodeLayout[]
  customDimensions?: CustomDimension
  selectedLayout?: Layout
  showResultToolbar?: boolean
  diagramDivider?: number
  codeDivider?: number
  resultDivider?: number
  previewDivider?: number
  customComponentResultDivider?: number
  customComponentCodeDivider?: number
  codeFeedbackDivider?: number
  consoleDivider?: number
  docsDivider?: number
  widgetExpanded?: WidgetType
  preserveLog?: boolean
  widgetDividerToChange?: CodeDividers.RESULT_DIVIDER | CodeDividers.PREVIEW_DIVIDER
  codeAIHelperDivider?: number
}
export type DimensionKey = keyof Dimension
export type targetKey = 'result' | 'codeAndResult'

export interface SetCustomWidgetDimensionsPayload {
  target: targetKey
  divider: DimensionKey
  value: number
}
export enum AiWidgetPos {
  LEFT = 'left',
  RIGHT = 'right'
}
